import { render } from "./GuestFooter.vue?vue&type=template&id=08d7cdb2&scoped=true"
import script from "./GuestFooter.vue?vue&type=script&lang=js"
export * from "./GuestFooter.vue?vue&type=script&lang=js"

import "./GuestFooter.vue?vue&type=style&index=0&id=08d7cdb2&scoped=true&lang=css"

import exportComponent from "/home/demit/Projects/SMS-Syariah/server/app/business/sms-pay-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d7cdb2"]])

export default __exports__